// @flow
import { defaultTheme } from 'themes/default'

import type { SocialNet, SocialProvider, SocialProviderList } from '../types/app'

export const SOCIAL_PROVIDERS: SocialProviderList = Object.freeze({
  VK: 'vkontakte',
  MAIL: 'mailru_oauth2',
  FB: 'facebook',
  OK: 'odnoklassniki',
  YANDEX: 'yandex',
  GOOGLE: 'google_oauth2',
})

export const SOCIAL_COLORS: {
  [key: SocialProvider]: {| bg: string, icon?: string, iconMobile?: string, hover: string |},
} = Object.freeze({
  [SOCIAL_PROVIDERS.VK]: {
    bg: '#2787f5',
    hover: '#3c93f6',
    icon: defaultTheme.colors.white,
    iconMobile: '#2787f5',
  },
  [SOCIAL_PROVIDERS.MAIL]: {
    bg: '#005ff9',
    hover: '#0051d4',
    icon: '#ff9e00',
    iconMobile: '#ff9e00',
  },
  [SOCIAL_PROVIDERS.FB]: {
    bg: '#3b589e',
    hover: '#324b86',
    icon: defaultTheme.colors.white,
    iconMobile: '#3b589e',
  },
  [SOCIAL_PROVIDERS.GOOGLE]: {
    bg: defaultTheme.colors.white,
    hover: defaultTheme.colors.alto,
  },
  [SOCIAL_PROVIDERS.OK]: {
    bg: '#f7931e',
    hover: '#d27d1a',
    icon: defaultTheme.colors.white,
    iconMobile: '#f7931e',
  },
  [SOCIAL_PROVIDERS.YANDEX]: {
    bg: defaultTheme.colors.white,
    hover: defaultTheme.colors.alto,
    icon: '#f00',
    iconMobile: '#f00',
  },
})

export const ORDERED_SOCIAL_NETWORKS = [
  SOCIAL_PROVIDERS.VK,
  SOCIAL_PROVIDERS.MAIL,
  SOCIAL_PROVIDERS.FB,
  SOCIAL_PROVIDERS.GOOGLE,
  SOCIAL_PROVIDERS.OK,
  SOCIAL_PROVIDERS.YANDEX,
]

export const SOCIAL_NETWORKS_MAP: {| [key: SocialProvider]: SocialNet |} = {
  [SOCIAL_PROVIDERS.VK]: {
    provider: SOCIAL_PROVIDERS.VK,
    href: '/user/auth/vkontakte',
    icon: 'vk',
    title: 'Вконтакте',
    tags: ['main'],
  },
  [SOCIAL_PROVIDERS.MAIL]: {
    provider: SOCIAL_PROVIDERS.MAIL,
    href: '/user/auth/mailru_oauth2',
    icon: 'mailru',
    title: 'Mail.ru',
    tags: ['main'],
  },
  [SOCIAL_PROVIDERS.FB]: {
    provider: SOCIAL_PROVIDERS.FB,
    href: '/user/auth/facebook',
    icon: 'fb',
    title: 'Facebook',
    tags: ['main'],
  },
  [SOCIAL_PROVIDERS.GOOGLE]: {
    provider: SOCIAL_PROVIDERS.GOOGLE,
    href: '/user/auth/google_oauth2',
    icon: 'google',
    title: 'Google',
    tags: ['main'],
  },
  [SOCIAL_PROVIDERS.OK]: {
    provider: SOCIAL_PROVIDERS.OK,
    href: '/user/auth/odnoklassniki',
    icon: 'ok',
    title: 'Одноклассники',
    tags: ['main'],
  },
  [SOCIAL_PROVIDERS.YANDEX]: {
    provider: SOCIAL_PROVIDERS.YANDEX,
    href: '/user/auth/yandex',
    icon: 'ya',
    title: 'Яндекс',
    tags: ['main'],
  },
}
